export default __webpack_public_path__ + "static/media/Resume-Zoe-Lederman.aa384f53.pdf";